import React from "react";
import "./loading.scss";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
